import ListSVG from "@design-system/ui-icons/vanilla/List"
import { createIcon } from "../createIcon"

export const ListIcon = createIcon(ListSVG)
